<template>
  <main class="lights">
      <div class="light" :class="{ lights__red: rate >= 3 }"></div>
      <div class="light" :class="{ lights__yellow: (rate > 1  && rate < 3) }"></div>
      <div class="light" :class="{ lights__green: rate === 1}"></div>
  </main>
</template>

<script>
export default {
  props: [ 'rate' ],
  computed: {
    salary() {
      return this.$store.state.salary;
    }
  }
}
</script>

<style lang="scss" scoped>
.card__singular--list__container__traffic {
  &.lights {
    height: 113px;
    width: 40px;
  }

  .light {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
}

.lights {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background: $gray;
  border-radius: $rounded;
  width: 1.1rem;
  height: 2.9rem;
  margin-right: .5rem;

  .light {
    width: .70rem;
    height: .70rem;
    border-radius: 50%;
    background: #CFCFCF;
  }

  &__green {
    background: $lightGreen !important;
  }

  &__yellow {
    background: $yellow !important;
  }

  &__red {
    background: $red !important;
  }
}
</style>